import React from 'react';
import FormReactSelectResidenceInput from '../formInputsV2/FormReactSelectResidenceInput';
import { FormInputText } from '../formInputsV2/FormInputText';
import { FormInputAddress } from '../formInputsV2/FormInputAddress';

function FormInputAddressHouseCompleteManual({
  municipalities,
  formData,
  isValid,
  errors,
  register,
  updateFormData,
}) {
  return (
    <>
      <FormInputAddress
        valueAddress={formData.current_address}
        valueHouse={formData.current_house_number}
        label="Indirizzo"
        onAddressChange={(value) => updateFormData({ current_address: value })}
        onHouseNumberChange={(value) => updateFormData({ current_house_number: value })}
        addressError={errors.current_address?.message}
        houseNumberError={errors.current_house_number?.message}
        validAddress={isValid('current_address')}
        validHouseNumber={isValid('current_house_number')}
      />
      <FormReactSelectResidenceInput
        label="Residenza"
        options={municipalities}
        values={{
          residence_commune_code: formData.house_commune_code,
          residence_province_code: formData.house_province_code,
          postal_code: formData.current_postal_code,
        }}
        onChange={(values) => updateFormData({
          house_commune_code: values.residence_commune_code,
          house_province_code: values.residence_province_code,
          current_postal_code: values.postal_code,
        })}
        valid={isValid('house_commune_code')}
      >
        <FormInputText
          label="Codice Postale"
          registration={register('current_postal_code')}
          error={errors.current_postal_code?.message}
          valid={isValid('current_postal_code')}
        />
      </FormReactSelectResidenceInput>
    </>
  );
}

export default FormInputAddressHouseCompleteManual;
